import React from 'react'

const Banner = ( {text}) => {
  return (
    <h1 className='text-center banner'>{text}</h1>
  )
}

export default Banner